module.exports = __webpack_public_path__ + "static/media/comm_github.cda411c2.png";